import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { useContext } from "react";
import { RmcContext } from "../context/RmcContext";
import { convertToUrlString } from "../../utils";

const overlayColors = [
  "rgba(187,202,249,0.5)",
  "rgba(249,187,187,0.5)",
  "rgba(187,249,201,0.5)",
  "rgba(249,230,187,0.5)",
  "rgba(220,187,249,0.5)",
  "rgba(187,240,249,0.5)",
];

const textColors = [
  "#2B539F",
  "#7f1d1d",
  "#14532d",
  "#7c2d12",
  "#4c1d95",
  "#164e63",
];

function Arenas({ x, bg, isCategory, index = 0 }) {
  const navigate = useNavigate();
  const { setBrandId, setSlug } = useContext(RmcContext);

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 3, delay: 0.4 }}
      className="rounded-2xl hover:scale-95 col-span-6"
      style={{
        backgroundImage: `url(${
          x.image_url.includes("default")
            ? "/image/arena_image.png"
            : x.image_url
        })`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
      onClick={() => {
        if (isCategory) {
          navigate(`/search/category/${convertToUrlString(x.name)}`);
        } else {
          setBrandId(x.id);
          setSlug(x.slug);
          navigate(`/worlds/${x.slug}?id=${x.id}`);
        }
      }}
    >
      <div
        className="grid relative p-3.5 rounded-2xl h-[123px]"
        style={{
          backgroundColor:
            index === 0
              ? "rgba(0,0,0,0.3)"
              : overlayColors[(index - 1) % overlayColors.length],
        }}
      >
        <div className="self-end">
          <p
            className="font-semibold text-left text-sm mt-2.5"
            style={{
              color:
                index === 0
                  ? "#ffffff"
                  : textColors[(index - 1) % textColors.length],
            }}
          >
            {x.name}
          </p>
        </div>
      </div>
    </motion.div>
  );
}

export default Arenas;
